<template>
    <div class="success">
        <div class="image">
            <img src="@/assets/vipCoach/v2/icon_jrcg.png" />
        </div>
        <div class="content">恭喜您成为{{$route.query.schoolName}}教练。我们非常欢迎您的加入，希望我们能携手并进共创辉煌。赶快使用手机号<span>{{$route.query.mobile | mobileFilter}}</span>登录斑斑教练APP进行学员推广获取收益吧。</div>
        <div class="join" @click="toApp">
            <a>立即前往斑斑教练APP>></a>
        </div>
    </div>
</template>
<script>
import { linkApp } from '../../utils'
export default {
    name: 'vipCoachRelationSuccess',
    filters: {
        mobileFilter (e) {
            return e.substr(0, 3) + '****' + e.substr(7)
        }
    },
    methods: {
        toApp () {
            // 生产环境的时候 替换地址
            const origin = location.origin.replace('app.chetailian.com', 'share.banbanjiadao.com').replace('app.banbanjd.cn', 'share.banbanjiadao.com')
            const andoridDownApp = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ctl.coach'
            const iosDownApp = `${origin}/ui/shops/vipCoach/down`
            linkApp(
                1, {
                    default: andoridDownApp,
                    custom: andoridDownApp
                }, {
                    default: iosDownApp,
                    custom: iosDownApp
                }
            )
        }
    }
}
</script>
<style lang="scss" scoped>
*{
    box-sizing: border-box;
}
img{
    max-width: 100%;
}
.success{
    padding: 42px 38px;
    .image{
        width: 201px;
        margin: 0 auto;
    }
    .content{
        margin-top: 50px;
        color: #333333;
        font-size: 15px;
        line-height: 24px;
        span{
            color: #FF5050;
        }
    }
}
.join{
    text-align: center;
    margin-top: 50px;
    text-align: center;
    a{
        font-size: 18px;
        line-height: 18px;
        font-weight: 600;
        color: #53CB85;
    }
}
</style>
